let locales = {
    cancel: "Cancel",
    send: "Send",
    save: "Save",
    desactivated: "Desactivated",
    active: "Active",
    voluntary_suspension: "Voluntary Suspension",
    involuntary_suspension: "Involuntary Suspension",
    cancelled: "Cancelled",
    rma: "RMA",
    inactive: "Inactive",

    //Menu - Sidebar
    menu_accounts: "Accounts",
    menu_devices: "Devices",
    menu_vidfleet: "Vidfleet",
    menu_settings: "Settings",
    menu_user_activity_logs: "User Activity Logs",
    menu_key_fobs: "DriverID Tags",
    menu_maintenance_warnings: "Maintenance Warnings",
    menu_camera_logs: "Camera Logs",
    menu_dms_statuses: "DMS Statuses",
    menu_power_lost: "Power Lost",
    menu_sd_card_status: "SD Card Status",
    menu_white_listed_devices: "White Listed Devices",
    menu_packages: "Packages",
    menu_pm_users: "PM Users",
    menu_jira_summary: "Jira Summary",
    manufacturers: "Manufacturers",
    menu_reports: "Reports",
    menu_cloud_lg_page: "Cloud Login Page",
    menu_dashboard: "Dashboard",
    menu_alert_types: "Alert Types",
    menu_transactions: "Transactions",
    menu_events: "Events",
    menu_sim_provider: "SIM Providers",
    menu_sim_provider_accounts: "SIM Provider Accounts",
    menu_sim_sms_systems: "SMS Systems",
    menu_dealers: "Dealers",
    menu_bulk_sms: "Mass SMS",
    menu_firmwares_reviews: "Firmwares",
    menu_brands: "Brands",
    menu_migrations: "Migrations",
    menu_video_review: "AI Video Reviews",

    //Menu - Account
    menu_account_change_password: "Change Password",
    menu_account_clear_caches: "Clear Caches",
    menu_account_temp_token: "Temp Token",
    menu_account_logout: "Logout",
    menu_account_account: "Account",
    menu_scheduled_actions: "Scheduled Actions",
    menu_unsubscribed_contacts: "Unsubscribed Contacts",
    menu_unsubscribed_warnings: "Warnings",
    menu_account_tags: "Tags",


    advanced_filters: "Advanced Filters",

    //forms
    required_field: "Required Field",
    density: "Density",
    refresh: "Refresh",
    search: "Search",
    export: "Export",
    changeColumnOrder: "Change column order",
    exportCSV: "Export CSV All Columns",
    exportCSVVisible: "Export CSV Visible Columns",
    exportPDF: "Export PDF",
    delete: "Delete",
    today: "Today",
    day: "Day",
    yerterday: "Yesterday",
    this_week: "This Week",
    last_week: "Last Week",
    this_month: "This Month",
    last_month: "Last Month",
    this_quarter: "This Quarter",
    last_quarter: "Last Quarter",
    edit: 'Edit',
    close: 'Close',
    activate: 'Activate',
    desactivate: 'Desactivate',
    custom: "Custom",
    email_is_invalid: "Email is invalid",

    //common
    common_copied: "Copied",
    common_from: "From",
    common_to: "To",
    common_cancel: "Cancel",
    common_field_required: "Field Required",
    common_enabled: "Enabled",
    common_disabled: "Disabled",
    common_on: "On",
    common_off: "Off",
    common_warning: "Warning",
    common_emergency: "Emergency",
    common_next: "Next",
    common_back: "Back",
    common_add: "Add",
    common_reset: "Reset",
    common_no_devices_added: "No devices added",
    common_no_keyfobs_added: "No driverID tags added",
    common_no_accounts_added: "No accounts added",
    common_active: "Active",
    common_inactive: "Inactive",
    error_password: "The password must have at least one number, one lowercase and one uppercase letter",
    no_devices_added: "No devices added",
    common_no_information_to_display: "No information to display",
    common_authentication_failed: "Authentication failed",
    common_camera_password_error: "Camera password error",
    common_camera_operation_failed: "Camera operation failed",
    common_camera_does_not_exist: "Camera does not exist",
    common_sync_camera_error: "Sync camera error",
    common_close: "Close",
    common_show: "Show",
    common_save: "Save",
    common_error_permission: "You do not have the necessary permits to perform this action",
    export_message: "Your file will be generated in a moment",
    very_weak: "Very weak",
    weak: "Weak",
    fair: "Fair",
    good: "Good",
    strong: "Strong",
    actions: "Actions",
    select: "Select",
    nextp: "next",
    prev: "prev",
    perPage: "per page",
    no_options: "No Options",
    split: "Split",
    no_split: "No Split",
    no_more_items: "There are no more items",

    // DataView ARIA accessibility messages
    common_dataview_aria_loading: "Loading data...",
    common_dataview_aria_loading_more: "Loading more items...",
    common_dataview_aria_error: "Error",
    common_dataview_aria_showing_items: "Showing {count} items",
    common_dataview_aria_table_region: "Data table",
    common_dataview_aria_table_label: "Data table with sortable columns",
    common_dataview_aria_column_moved_left: "{column} column moved left",
    common_dataview_aria_column_moved_right: "{column} column moved right",
    common_dataview_aria_drag_to_reorder: "Drag to reorder column",
    english_label: "English",
    spanish_label: "Spanish",
    common_new: "New",
    common_old: "Old",
    common_yes: "Yes",
    common_no: "No",
    common_show_changes: "Show Changes",
    common_remove: "Remove",
    common_edit_assign: "Edit Assignments",
    common_expand: "Expand",
    common_contract: "Contract",
    common_loading: "Loading",
    common_copy: "Copy",
    common_clear: "Clear",
    common_continue: "Continue",
    common_changes: "Changes",
    common_unit_time: "Unit Time",
    common_server_time: "Server Time",
    Dealer: "Dealer",
    Network: "Network",
    Manufacturer: "Manufacturer",
    "Device Model": "Device Model",
    "Asset Type": "Asset Type",
    "Offline Days": "Offline Days",
    Warning: "Warning",
    Date: "Date",
    Permission: "Permission",
    Report: "Report",
    lastEventName: "Last Event Name",
    simType: "Sim Type",
    manufacturer: "Manufacturer",
    Event: "Event",
    common_now: "Now",
    common_schedule: "Schedule",
    common_executed: "Executed",
    common_not_executed: "Scheduled",
    common_error_format: "The format is not correct",
    common_hour: "Hour",
    common_mins: "Mins",
    common_seconds: "Seconds",
    common_set: "Set",
    common_hour_no_valid: "Hour no valid",
    common_resend: "Resend",
    common_change: "Change",
    common_untagged: "Untagged",
    common_download: "Download",
    common_accept: "Accept",
    //new
    pmexportlogs: "PM Export Logs",
    scheduledreports: "Scheduled Reports",
    systemalertlog: "System Alert Log",
    accounts: "Accounts",
    activities: "Activities",
    useractivitylogs: "User Activity Logs",
    alerttypes: "Alert Types",
    devicesreadings: "Devices Readings",
    maintenancewarnings: "Maintenance Warnings",
    commands: "Commands",
    notes: "Notes",
    calampfiles: "Calamp Files",
    devices: "Devices",
    troubleshooting_events: "Troubleshooting Events",
    usertroubleshooting: "User Troubleshooting",
    importp4: "Import P4",
    importaccount: "Import Account",
    keyfobs: "Key Fobs",
    cannedcommands: "Canned Commands",
    devicemodels: "Device Models",
    firmwares: "Firmwares",
    partnumbers: "Part Numbers",
    unittypes: "Unit Types",
    unittype_events: "Unit Type Events",
    manufacturers: "Manufacturers",
    assignedto: "Assigned To",
    packages: "Packages",
    jirasummary: "Jira Summary",
    pmusers: "PM Users",
    rawdata: "Raw Data",
    reports: "Reports",
    scheduledactions: "Scheduled Actions",
    simprovideraccounts: "Sim Provider Accounts",
    simproviders: "Sim Providers",
    smssystems: "SMS Systems",
    transactionsdetails: "Transactions Details",
    transactionsrequests: "Transactions Requests",
    transactionsresults: "Transactions Results",
    unsubscribedcontacts: "Unsubscribed Contacts",
    users: "Users",
    changeshistory: "Changes History",
    cameralogs: "Camera Logs",
    dmsstatuses: "DMS Statuses",
    powerlost: "Power Lost",
    sdcardstatuses: "SDCARD Statuses",
    whitelisteddevices: "White Listed Devices",
    statusUpdate: "Change Status",
    Active: "Active",
    Pending: "Pending",
    Expired: "Expired",
    "Voluntary Suspension": "Voluntary Suspension",
    "Involuntary Suspesion": "Involuntary Suspesion",
    Cancelled: "Cancelled",
    insert: "Insert",
    update: "Update",
    delete: "Delete",
    other: "Other",
    "Card Number": "Card Number",
    completed: "Completed",
    fail: "Fail",
    "Date Range": "Date Range",
    sent: "Sent",
    pending: "Pending",
    command: "Command",
    accepted: "Accepted",
    rejected: "Rejected",
    emailRecipients: "Email Recipients",
    recipients: "Recipients",
    smsIntegrationId: "Sms Integration Id",
    mass_sms_request_has_ended: "The mass sms request has ended. Click here to see the status",
    mass_sms_request_has_been_received: "The mass sms request has been received. Click here to view the status",
    failed: "Failed",
    complete: "Complete",
    failure: "Failure",

    //CerebrumX packages
    package_premium: "PREMIUM",
    package_advanced: "ADVANCED",
    package_basic: "BASIC",
    noMoreItems: "There are no more items.",
    // RQ-ERR-06: ErrorIndicator messages for infinite scroll
    common_dataview_error_loading_more: "Failed to load more items. Please try again.",
    common_dataview_retry: "Retry",
    //months list
    month_jan: "JAN",
    month_feb: "FEB",
    month_mar: "MAR",
    month_apr: "APR",
    month_may: "MAY",
    month_jun: "JUN",
    month_jul: "JUL",
    month_aug: "AUG",
    month_sep: "SEP",
    month_oct: "OCT",
    month_nov: "NOV",
    month_dec: "DEC",

    untagged: "Untagged",
    start_typing_to_search: "Start typing to search",


    //videoEvents Helpers
    video_event_type_asleep: "Asleep",
    video_event_type_drivingHit: "Sudden Stop",
    video_event_type_dayDreaming: "Day Dreaming",
    video_event_type_distracted: "Distracted",
    video_event_type_drowsy: "Drowsy",
    video_event_type_hardAccel: "Rapid Acceleration",
    video_event_type_hardBrake: "Hard Brake",
    video_event_type_sharpTurn: "Hard Turn",
    video_event_type_manual: "Manual",
    video_event_type_noSeatBelt: "No Seatbelt",
    video_event_type_smoking: "Smoking",
    video_event_type_usingPhone: "Using Phone",
    video_event_type_yawn: "Yawn",
    video_event_type_collisionWarning: "Collision Warning",
    video_event_type_laneDeparture: "Lane Departure",
    video_event_type_closeFollowing: "Close Following",
    video_event_type_tailgating: "Tailgating",
    video_event_type_stopSignViolation: "Stop Sign Violation",
    video_event_type_noDriver: "Camera Obstructed",
    video_event_type_idleNoDriver: "Idle No Driver",
    video_event_type_potentialIncident: "Potential Incident",
    video_event_type_passengerInside: "Passenger Inside",
    video_event_type_potentialIncidentMedium: "Potential Incident Medium",

    boolean_true: "True",
    boolean_false: "False",

    common_remove: "Remove",
    common_pending: "Pending",
    common_in_progress: "In Progress",
    common_done: "Done",
    common_done_with_errors: "Done with Errors",
    common_failed: "Failed",

    // DataViewInfiniteScroll - Empty States
    common_dataview_empty_initial: "Select your filters to search your items",
    common_dataview_empty_no_data: "No items available",
    common_dataview_empty_filtered: "No results match your filters",
    common_dataview_empty_search: "No results found for your search",
    common_dataview_empty_error: "Unable to load data",

    // DataViewInfiniteScroll - Selection
    common_dataview_selection_limit_reached: "Maximum selection limit reached ({max} items)",
    common_dataview_selection_limit_title: "Selection Limit",
    common_dataview_selection_limit_exceeded: "Selection limited to {max} items. {excess} items were not selected.",
    common_dataview_selection_limit_tooltip: "Cannot select more items. Maximum {max} items allowed.",
    common_dataview_search_limit_reached: "Search limited to {max} items. Remove some items to add new ones.",
    common_dataview_search_limit_title: "Search Limit",

    // DataViewInfiniteScroll - UI Labels
    common_dataview_drag_to_reorder: "Drag to reorder column",
    common_dataview_total_label: "Total",

}

import security from 'Core/.globals/lan/en';
import accounts from 'Modules/accounts/.globals/lan/en';
import dealers from 'Modules/dealers/.globals/lan/en';
import devices from 'Modules/devices/.globals/lan/en';
import keysFobs from 'Modules/keysFobs/.globals/lan/en';
import users from 'Modules/users/.globals/lan/en';
import activities from 'Modules/activities/.globals/lan/en';
import pmUsers from 'Modules/pmUsers/.globals/lan/en';
import packages from 'Modules/packages/.globals/lan/en';
import rawData from 'Modules/rawData/.globals/lan/en';
import vidfleet from 'Modules/vidfleet/.globals/lan/en';
import transactions from 'Modules/transactions/.globals/lan/en';
import commonModules from 'Modules/.common/.components/vidfleetInformation/lan/en';
import manufacturers from 'Modules/manufacturers/.globals/lan/en';
import reports from 'Modules/reports/.globals/lan/en';
import importP4 from 'Modules/importP4/.globals/lan/en';
import importAccount from 'Modules/importAccount/.globals/lan/en';
import loginPage from 'Modules/loginPage/.globals/lan/en';
import dashboard from 'Modules/dashboard/.globals/lan/en';
import alertTypes from 'Modules/alertTypes/.globals/lan/en';
import scheduledActions from 'Modules/scheduledActions/.globals/lan/en';
import events from 'Modules/events/.globals/lan/en';
import unsubscribedContacts from 'Modules/unsubscribedContacts/.globals/lan/en';
import simProviders from 'Modules/simProviders/.globals/lan/en';
import simProviderAccounts from 'Modules/simProviderAccounts/.globals/lan/en';
import smsSystems from 'Modules/smsSystems/.globals/lan/en';
import maintenanceWarningEvents from 'Modules/maintenanceWarningEvents/.globals/lan/en';
import tags from 'Modules/tags/.globals/lan/en';
import brands from 'Modules/brands/.globals/lan/en';
import resetPassword from 'Modules/.common/.components/resetPassword/lan/en';
import resetEmail from 'Modules/.common/.components/resetEmail/lan/en';
import resendInvite from 'Modules/.common/.components/resendInvite/lan/en';

locales = {
    ...locales,
    ...security,
    ...accounts,
    ...dealers,
    ...devices,
    ...keysFobs,
    ...users,
    ...activities,
    ...pmUsers,
    ...packages,
    ...rawData,
    ...vidfleet,
    ...transactions,
    ...commonModules,
    ...manufacturers,
    ...reports,
    ...importP4,
    ...importAccount,
    ...loginPage,
    ...dashboard,
    ...alertTypes,
    ...scheduledActions,
    ...events,
    ...unsubscribedContacts,
    ...simProviders,
    ...simProviderAccounts,
    ...smsSystems,
    ...maintenanceWarningEvents,
    ...tags,
    ...brands,
    ...resetPassword,
    ...resetEmail,
    ...resendInvite,
}

export default locales;